import React from 'react'
import { Formik, Form } from 'formik'
import styled from 'styled-components'
import { PasswordInput } from '../../../components/form-components/inputs.component'
import Button from '../../../components/buttons/buttons.component'
import PropTypes from 'prop-types'
import Yup from './../../../helpers/custom-yup'

const schema = Yup.object().shape({
	password: Yup.string().password().required('Informe a nova senha'),
	passwordConfirmation: Yup.string()
		.equalTo(Yup.ref('password'), 'As senhas digitadas não conferem')
		.required('Informe a confirmação da nova senha'),
})

const StyledFormContainer = styled.div`
	.form {
		display: flex;
		flex-direction: column;
		margin: 0 auto;
		width: 350px;
	}

	@media (max-width: 380px) {
		.form {
			width: 90%;
		}
	}

	.button {
		align-self: center;
		margin-top: 5rem;
		width: fit-content;

		@media screen and (max-width: 700px) {
			width: 100%;
		}
	}
`

const StyledInputContainer = styled.div`
	margin-top: 4rem;
`

export class RedefinePasswordForm extends React.Component {
	render() {
		const { onSubmit , title} = this.props
		return (
			<StyledFormContainer>
				<Formik
					initialValues={{
						password: '',
						passwordConfirmation: '',
					}}
					onSubmit={onSubmit}
					validationSchema={schema}
					render={(props) => (
						<Form className="form">
							<StyledInputContainer>
								<p className="static-information">
									A sua senha deve ter no mínimo 12 caracteres e conter
									pelo menos uma letra maiúscula, uma letra minúscula,
									1 número e 1 caractere especial
								</p>
								<br />
								<br />
								<PasswordInput
									id="password"
									label="Digite a sua nova senha"
									autoFocus={true}
									maxLength={256}
									{...props}
								/>
							</StyledInputContainer>
							<StyledInputContainer>
								<PasswordInput
									id="passwordConfirmation"
									label="Redigite a sua nova senha"
									maxLength={256}
									{...props}
								/>
							</StyledInputContainer>
							<Button primary className="button" type="submit">
								{title === '1' ? 'Definir senha' : 'Alterar senha'}
							</Button>
						</Form>
					)}
				/>
			</StyledFormContainer>
		)
	}
}

RedefinePasswordForm.propTypes = {
	onSubmit: PropTypes.func.isRequired,
}
